import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiSend } from "react-icons/fi";

const mockGroups = {
  1: {
    name: "Tosin Group CTO",
    members: 12,
    messages: [
      { sender: "Tosin", text: "Welcome everyone!", time: "2m ago" },
      { sender: "You", text: "Glad to be here!", time: "1m ago" },
    ],
  },
  2: {
    name: "Baa Moridiyah Coalition",
    members: 45,
    messages: [{ sender: "Baa", text: "Meeting starts at 4pm!", time: "15m ago" }],
  },
};

const GroupChatPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [group, setGroup] = useState(mockGroups[id] || mockGroups[1]);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [group]);

  const handleSend = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setGroup({
      ...group,
      messages: [...group.messages, { sender: "You", text: message, time: "now" }],
    });
    setMessage("");
  };

  return (
    <div style={styles.chatContainer}>
      {/* Header */}
      <div style={styles.header}>
        <FiArrowLeft
          size={22}
          style={styles.backIcon}
          onClick={() => navigate("/admin/create-group-chat")}
        />
        <div>
          <h2 style={styles.groupName}>{group.name}</h2>
          <p style={styles.members}>{group.members} members</p>
        </div>
      </div>

      {/* Messages */}
      <div style={styles.messages}>
        {group.messages.map((msg, i) => (
          <div
            key={i}
            style={{
              ...styles.msgBubble,
              alignSelf: msg.sender === "You" ? "flex-end" : "flex-start",
              backgroundColor: msg.sender === "You" ? "#2563eb" : "#e5e7eb",
              color: msg.sender === "You" ? "#fff" : "#111827",
              borderBottomRightRadius: msg.sender === "You" ? "4px" : "12px",
              borderBottomLeftRadius: msg.sender === "You" ? "12px" : "4px",
            }}
          >
            <p style={styles.msgText}>{msg.text}</p>
            <small style={styles.msgTime}>{msg.time}</small>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>

      {/* Input Bar */}
      <form onSubmit={handleSend} style={styles.inputBar}>
        <input
          type="text"
          placeholder="Type a message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={styles.input}
        />
        <button type="submit" style={styles.sendBtn}>
          <FiSend size={20} />
        </button>
      </form>
    </div>
  );
};

const styles = {
  chatContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor: "#f9fafb",
    fontFamily: "Inter, sans-serif",
    position: "relative",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "#2563eb",
    color: "#fff",
    padding: "14px 20px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  },
  backIcon: {
    cursor: "pointer",
    color: "#fff",
    transition: "transform 0.2s ease",
  },
  groupName: { margin: 0, fontSize: "18px", fontWeight: "700" },
  members: { margin: 0, fontSize: "13px", opacity: 0.85 },
  messages: {
    flex: 1,
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    overflowY: "auto",
    backgroundColor: "#f1f5f9",
  },
  msgBubble: {
    padding: "10px 14px",
    borderRadius: "12px",
    maxWidth: "70%",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    wordWrap: "break-word",
  },
  msgText: { margin: 0, fontSize: "14.5px", lineHeight: "1.4" },
  msgTime: {
    fontSize: "11px",
    opacity: 0.7,
    marginTop: "4px",
    display: "block",
    textAlign: "right",
  },

  /* ---------- Input area ---------- */
  inputBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 26px",
    backgroundColor: "#fff",
    borderTop: "1px solid #e5e7eb",
    position: "sticky",
    bottom: 0,
    zIndex: 10,
  },

  input: {
    flex: 1,
    border: "1px solid #e2e8f0",
    borderRadius: "30px",
    padding: "14px 20px",
    outline: "none",
    fontSize: "15px",
    backgroundColor: "#f9fafb",
    transition: "box-shadow 0.15s ease, border-color 0.15s ease",
    width: "calc(100% - 130px)", // ✅ reduce width slightly from the right
  },


  /* ✅ Floating send button */
  sendBtn: {
    position: "absolute",
    right: "30px",
    bottom: "20px", // lifts the button up above the input bar
    backgroundColor: "#2563eb",
    border: "none",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 8px 20px rgba(37,99,235,0.3)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    zIndex: 20,
  },
};

export default GroupChatPage;
